import { combineMultipleReducers } from "../utils/combineMultipleReducers";
import { consoledOnce } from "../utils/consoleOnce";
export class Dynadux {
    constructor(_config = {}) {
        this._config = _config;
        this._dispatches = [];
        this._isDispatching = false;
        this.addReducers = (reducers) => {
            this._reducers = combineMultipleReducers(this._reducers, reducers);
        };
        this.dispatch = (action, payload, dispatchConfig = {}) => {
            this._dispatches.push({
                action,
                payload,
                dispatchConfig,
            });
            this._dispatch();
        };
        this._onChange = (_state, _action, _payload) => undefined;
        this._dispatch = () => {
            if (this._isDispatching)
                return;
            this._isDispatching = true;
            const dispatchItem = this._dispatches.shift();
            if (!dispatchItem) {
                this._isDispatching = false;
                return;
            }
            if (typeof dispatchItem.dispatchConfig.triggerChange !== "undefined")
                consoledOnce('warn', 'Dynadux: `triggerChange` config prop is deprecated and will be not accepted on next major version. Use the `blockChange` (with the opposite logic) instead.');
            const { action, payload, dispatchConfig: { blockChange: userBlockChange = false, triggerChange = true, }, } = dispatchItem;
            const reducer = this._reducers[action];
            const initialState = this._state;
            let newState = Object.assign({}, this._state);
            let changed = false;
            let blockChange = userBlockChange || !triggerChange;
            const { middlewares = [] } = this._config;
            try {
                middlewares
                    .filter(Boolean)
                    .forEach(({ before }) => {
                    if (!before)
                        return;
                    const middlewarePartialChange = before({
                        action,
                        payload,
                        dispatch: this.dispatch,
                        state: newState,
                    });
                    if (!changed && !!middlewarePartialChange)
                        changed = true;
                    if (!middlewarePartialChange)
                        return;
                    newState = Object.assign(Object.assign({}, newState), middlewarePartialChange);
                });
            }
            catch (e) {
                console.error('Dynadux: A middleware on `before` raised an exception', e);
            }
            const reducerStart = Date.now();
            try {
                if (reducer) {
                    const reducerPartialState = reducer({
                        action,
                        payload,
                        dispatch: this.dispatch,
                        state: newState,
                        blockChange: () => blockChange = true,
                    });
                    if (!changed && !!reducerPartialState)
                        changed = true;
                    newState = Object.assign(Object.assign({}, this._state), reducerPartialState);
                }
            }
            catch (e) {
                console.error('Dynadux: A reducer raised an exception', e);
            }
            try {
                const reducerElapsedMs = Date.now() - reducerStart;
                middlewares
                    .filter(Boolean)
                    .forEach(({ after }) => {
                    if (!after)
                        return;
                    const middlewarePartialChange = after({
                        action,
                        payload,
                        dispatch: this.dispatch,
                        state: newState,
                        initialState,
                        changed,
                        reducerElapsedMs,
                    });
                    if (!changed && !!middlewarePartialChange)
                        changed = true;
                    if (!middlewarePartialChange)
                        return;
                    newState = Object.assign(Object.assign({}, newState), middlewarePartialChange);
                });
            }
            catch (e) {
                console.error('Dynadux: A middleware on `after` raised an exception', e);
            }
            this._state = newState;
            if (changed && !blockChange && this._config.onChange)
                this._config.onChange(this._state, action, payload);
            if (changed && !blockChange)
                this._onChange(this._state, action, payload);
            if (this._config.onDispatch)
                this._config.onDispatch(action, payload);
            this._isDispatching = false;
            this._dispatch();
        };
        const { initialState = {}, reducers = {}, middlewares = [], } = this._config;
        this._state = initialState;
        this._reducers =
            Array.isArray(reducers)
                ? combineMultipleReducers(...reducers)
                : reducers;
        middlewares.forEach(middleware => middleware && middleware.init && middleware.init(this));
    }
    get state() {
        return this._state;
    }
    setSectionInitialState(section, sectionState) {
        this._state[section] = sectionState;
    }
}
